<template lang="pug">
action-bar(
  :entity="entity"
  @perform="opts => $emit('perform', opts)"
  :title="`Serviço: ${title}`"
)
  template(#right)

    //- BOTÃO DE ATUALIZAR
    v-tooltip(bottom)
      template(#activator="{ on, attrs }")
        v-btn.mx-1(
          icon
          v-bind="attrs"
          v-on="on"
          @click="$emit('refresh')"
        )
          v-icon mdi-refresh
      span
        span.text-md.font-weight-medium Atualizar
        br
        span.font-weight-light Sincroniza os dados da grade com o servidor de dados.
</template>

<script>
import ActionBar from '@/components/commons/action-bar/ActionBar'

export default {
  components: {
    ActionBar,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,

    busy: Boolean,

    /** @type {Keep.Paper.Design.Set} */
    set: Object,
    /** @type {Keep.Paper.Design.Row} */
    row: Object,
  },

  data: () => ({
  }),

  computed: {
    title: vm => vm.entity?.title || vm.entity?.name || vm.entity?.eref,

    rows: vm => vm.set.rows || [0],
    total: vm => vm.rows.length,
    index: vm => vm.rows.indexOf(vm.row),
    browsable: vm => vm.total > 1,

    color: vm => vm.row['@row']?.style?.toLowerCase(),

    page: {
      get () { return this.index + 1 },
      set (value) {
        this.$emit('goto', value - 1)
      }
    },

    autoRestoreSeconds: {
      get () {
        return this.entity?.autoRefresh || 0
      },
      set (value) {
        this.entity && (this.entity.autoRefresh = value)
      }
    },

    autoRestoreIntervals () {
      const intervals = [
        { seconds: 2,     text: '2 segundos'          },
        { seconds: 3,     text: '3 segundos'          },
        { seconds: 5,     text: '5 segundos'          },
        { seconds: 10,    text: '10 segundos'         },
        { seconds: 20,    text: '20 segundos'         },
        { seconds: 30,    text: '30 segundos'         },
        { seconds: 60,    text: '1 minuto'            },
        { seconds: 60*60, text: '1 hora'              },
        { seconds: 0,     text: 'Atualização manual'  },
      ]
      const current = this.autoRestoreSeconds
      intervals.forEach(interval =>
        interval.selected = (interval.seconds === current)
      )
      return intervals
    },
  },
}
</script>